export const precisionFormats = {
    days: 'DD. MM. YYYY',
    months: 'MM. YYYY',
    years: 'YYYY',
    default: 'MM. YYYY',
}

export const ACTIVITIES_TRADES_TABLE_CHANGE = 'ACTIVITIES_TRADES_TABLE_CHANGE'
export const ACTIVITIES_TRADES_TABLE_CHANGE_REQUEST = (id) => `ACTIVITIES_TRADES_${id}_TABLE_CHANGE_REQUEST`
export const ACTIVITIES_TRADES_TABLE_DATA_RECEIVED = 'ACTIVITIES_TRADES_TABLE_DATA_RECEIVED'
export const ACTIVITIES_TRADES_TABLE_LOADING_TRUE = 'ACTIVITIES_TRADES_TABLE_LOADING_TRUE'
export const ACTIVITIES_TRADES_TABLE_LOADING_FALSE = 'ACTIVITIES_TRADES_TABLE_LOADING_FALSE'
